import { track } from '@vercel/analytics';

/**
 * Our own server route that starts the GovX ID OAuth (explicit) flow. It mints
 * the CSRF state server-side, redirects to GovX, and on successful verification
 * mints a single-use Shopify discount code (see app/api/govx/*).
 */
export const GOVX_AUTHORIZE_PATH = '/api/govx/authorize';

export const isGovxEligible = (region: string | undefined | null): boolean =>
  Boolean(region && region.toUpperCase() === 'US');

export type GovxSurface = 'heroes';

export const openGovxVerify = (
  surface: GovxSurface,
  region: string | undefined | null,
): void => {
  track('govx_verify_click', { surface, region: region ?? '' });
  if (typeof window !== 'undefined') {
    const url = region
      ? `${GOVX_AUTHORIZE_PATH}?region=${encodeURIComponent(region)}`
      : GOVX_AUTHORIZE_PATH;
    window.location.assign(url);
  }
};
